import { observer } from 'mobx-react-lite';
import { Navigate } from 'react-router-dom';

import { routes } from '@/constants/routes';

export const Main = observer(() => <Navigate to={routes.mint} replace />);

export default Main;
